import { Injectable } from '@angular/core';
import { extractValues } from '@mavles/shared';
import { BrowserStorageKey } from '@mavles/data';
import { User } from '@models/user/user';

@Injectable({
  providedIn: 'root'
})
export class AppStorageService {

  getData<T>(storageKey: BrowserStorageKey): T | undefined {
    const key = `${storageKey.toString()}-${this.getUser()?.id}`;
    const storedData = localStorage.getItem(key);
    return storedData ? JSON.parse(storedData) as T : undefined;
  }

  setData(key: BrowserStorageKey, value: any) {
    const user = this.getUser();
    if(user?.id && value) {
      localStorage.setItem(`${key.toString()}-${user?.id}`, JSON.stringify(value));
    }
  }

  removeData(key: BrowserStorageKey) {
    const user = this.getUser();
    if(user?.id) {
      localStorage.removeItem(`${key.toString()}-${user?.id}`);   
    }
  }

  saveUser(user: User): void {
    const mUser = extractValues(user, ['id', 'name', 'email', 'role', 'roles', 'is_admin', 'is_supervisor', 'firstname', 'lastname']);
    localStorage.setItem(BrowserStorageKey.User.toString(), JSON.stringify(mUser));
  }

  getUser(): User | undefined {
    const storedData = localStorage.getItem(BrowserStorageKey.User.toString());
    return storedData ? JSON.parse(storedData) as User : undefined;
  }

}
